import { VariantProps } from '@stitches/react'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { TranslationKeys } from 'locales/translationKeys'
import Trans from 'next-translate/Trans'
import { CustomVerticalSeparator, StackContainer, TextContainer } from './TextBlock.styles'

type TextBlockVariants = VariantProps<typeof StackContainer>

type TextBlockProps = TextBlockVariants & {
  i18nKey: TranslationKeys
  reversed?: boolean
}

export const TextBlock = ({ i18nKey, reversed, variant }: TextBlockProps) => {
  return (
    <StackContainer variant={variant}>
      <Stack
        reversed={reversed}
        direction={{ '@bp2': 'row', '@initial': 'column' }}
        gap={{ '@initial': '2', '@bp2': '12' }}
      >
        <CustomVerticalSeparator reversed={reversed} color="accent-black" css={{ width: '1px' }} />

        <TextContainer>
          <Stack direction="column" gap="5">
            <Trans
              i18nKey={i18nKey}
              components={{
                bold: (
                  <Text
                    color="accent-black"
                    size="headline"
                    weight="semiBold"
                    css={{ display: 'inline' }}
                  />
                ),
                block: <Text color="accent-black" size="headline" />,
                helsinkyUniversityStudyLink: (
                  <Text
                    as="a"
                    target="_blank"
                    href="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0225675"
                    color="accent-black"
                    size="headline"
                    css={{ display: 'inline', textDecoration: 'underline' }}
                  />
                ),
              }}
            />
          </Stack>
        </TextContainer>
      </Stack>
    </StackContainer>
  )
}
